var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVisits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_564",
    "data-name": "Group 564",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_264",
    "data-name": "Rectangle 264",
    width: 30,
    height: 30,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_563",
    "data-name": "Group 563",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12710",
    "data-name": "Path 12710",
    d: "M30,15A15,15,0,1,1,15,0,15,15,0,0,1,30,15",
    fill: "#7c97c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12711",
    "data-name": "Path 12711",
    d: "M13.152,15.254a3.911,3.911,0,1,1,3.911-3.912,3.916,3.916,0,0,1-3.911,3.912m0-6.281a2.369,2.369,0,1,0,2.369,2.369,2.371,2.371,0,0,0-2.369-2.369",
    transform: "translate(1.848 1.486)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12712",
    "data-name": "Path 12712",
    d: "M14.057,26.724l-.5-.421C13.2,26,4.716,18.747,4.716,12.248a9.341,9.341,0,1,1,18.683,0c0,6.5-8.483,13.748-8.844,14.054Zm0-22.276a7.809,7.809,0,0,0-7.8,7.8c0,4.946,6.008,10.8,7.8,12.434,1.792-1.636,7.8-7.489,7.8-12.434a7.809,7.809,0,0,0-7.8-7.8",
    transform: "translate(0.943 0.581)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisits);
export default __webpack_public_path__ + "static/media/icon-visits.5032009e5432eccad0e6aa79e4db7867.svg";
export { ForwardRef as ReactComponent };